import { render, staticRenderFns } from "./ForgotPasswordPage.vue?vue&type=template&id=106536a7&scoped=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordPage.vue?vue&type=style&index=0&id=106536a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106536a7",
  null
  
)

export default component.exports